export default __webpack_public_path__ + "static/petiteMaro5.mobile.inspirations-40ecf54bceb1373dfe5066e81cecb972.jpg";